import { Heading, Text, Box, Flex } from "components";
import { theme } from "@ovou-inc/ovou-ui";
import { memo } from "react";

interface IModalHeaderProps {
  assignedAndPendingSeats: number;
  totalSeats: number;
}

export const ModalHeader = memo(function ModalHeader({
  assignedAndPendingSeats,
  totalSeats,
}: IModalHeaderProps) {
  return (
    <>
      <Heading as="h3" fontSize="2xl" fontWeight="extrabold" color="black">
        Invite Users
      </Heading>
      <Box>
        <Text
          fontSize="16px"
          fontWeight="400"
          marginTop="8px"
          marginBottom="16px"
          color={theme.palette.ui.greys.grey1}
        >
          Type or paste the emails you want to invite.
        </Text>
        <Flex>
          <Text
            color={theme.palette.brand.primary.orange}
            fontSize="16px"
            fontWeight="600"
          >
            {assignedAndPendingSeats} Assigned
          </Text>
          <Text
            color={theme.palette.ui.greys.grey3}
            fontSize="16px"
            fontWeight="600"
          >
            &nbsp;/&nbsp;
          </Text>
          <Text
            color={theme.palette.ui.blackShades.black}
            fontSize="16px"
            fontWeight="400"
          >
            {totalSeats} Seats
          </Text>
        </Flex>
      </Box>
    </>
  );
});
